import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class LoadingRequestCounterService {
    private _count = 0
    private _isLoading = new BehaviorSubject<boolean>(false)
    public readonly isLoading$ = this._isLoading.asObservable()

    get count() {
        return this._count
    }

    increment() {
        this._count++
        if (this._count === 1) {
            this._isLoading.next(true)
        }
        // debug
        // console.debug('[LoadingRequestCounter] increment ->', this._count)
    }

    decrement() {
        if (this._count <= 0) {
            // console.warn('[LoadingRequestCounter] decrement called but count is already <= 0')
            this._count = 0
            this._isLoading.next(false)
            return
        }
        this._count--
        // debug
        // console.debug('[LoadingRequestCounter] decrement ->', this._count)
        if (this._count === 0) {
            this._isLoading.next(false)
        }
    }

    reset() {
        this._count = 0
        this._isLoading.next(false)
        // console.warn('[LoadingRequestCounter] reset called')
    }
}
